import React from 'react';

export class SerialCustomToolbarSelect extends React.Component {
  render() {
    return <></>;
  }
}
